export default "__VITE_ASSET__djISHcFP__"